<div class="sb-section-header">
    @if (showDivider()) {
        <div class="sb-section-header-divider">
            <lib-divider></lib-divider>
        </div>
    }
    <div class="sb-section-header-content-wrapper">
        <div class="sb-section-header-text-wrapper">
            @switch (size()) {
                @case (SectionHeaderSize.Small) {
                    <h5>
                        <ng-container *ngTemplateOutlet="titleTemplate"></ng-container>
                    </h5>
                    <small #subtitleContent [hidden]="!subtitleContent.textContent" class="sb-section-header-subtitle">
                        <ng-container *ngTemplateOutlet="subtitleTemplate"></ng-container>
                    </small>
                }
                @case (SectionHeaderSize.Medium) {
                    <h4>
                        <ng-container *ngTemplateOutlet="titleTemplate"></ng-container>
                    </h4>
                    <small #subtitleContent [hidden]="!subtitleContent.textContent" class="sb-section-header-subtitle">
                        <ng-container *ngTemplateOutlet="subtitleTemplate"></ng-container>
                    </small>
                }
            }
        </div>
    </div>
</div>
<ng-template #titleTemplate>
    <ng-content select="[title]"></ng-content>
</ng-template>
<ng-template #subtitleTemplate>
    <ng-content select="[subtitle]"></ng-content>
</ng-template>
